import { Body2 } from "@iventis/styles/src/components/texts";
import { Content } from "@iventis/translations/content/typed-content";
import { Theme, css } from "@emotion/react";
import React from "react";
import { styled } from "@iventis/styles";
import { useIventisTranslate } from "@iventis/translations/use-iventis-translate";
import { IVENTIS_PRIVACY_POLICY_URL, IVENTIS_TERMS_URL, CONTACT_URL } from "@iventis/utilities";

const StyledFooter = styled.div`
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;

    padding-bottom: 50px;
`;

export const StyledFooterLink = styled.a`
    ${({ theme }: { theme: Theme }) => css`
        color: ${theme.typographyColors.subdued};
    `};
    margin-right: 10px;
    margin-left: 10px;
`;

export const IventisFooter = () => {
    const translate = useIventisTranslate();
    return (
        <StyledFooter id="bottom">
            <Body2>
                <StyledFooterLink className="link" target="_blank" rel="noreferrer" href={IVENTIS_TERMS_URL}>
                    {translate(Content.login.footer.terms)}
                </StyledFooterLink>
                <StyledFooterLink target="_blank" rel="noreferrer" href={IVENTIS_PRIVACY_POLICY_URL}>
                    {translate(Content.login.footer.policy)}
                </StyledFooterLink>
                <StyledFooterLink target="_blank" rel="noreferrer" href={CONTACT_URL}>
                    {translate(Content.login.footer.contact)}
                </StyledFooterLink>
            </Body2>
        </StyledFooter>
    );
};
